/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  SettingsService,
  ISettingsMethods,
  UserListsService,
  IUserListsMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  IInviteUserMethods,
  InviteUserService,
  PresentationListsService,
  IPresentationListsMethods,
  ISendPurchaseInviteMethods,
  SendPurchaseInviteUserService,
  ISearchEmailMethods,
  SearchEmailService,
  IUserDropDownListsMethods,
  UserDropDownListsService,
  ICheckCountInviteMethods,
  CheckCountInviteService,
  CommitteListService,
  ICommitteListMethods,
  IUpdateMaxInvitesMethods,
  IReInviteUserMethods,
  ReInviteUserService,
  UpdateMaxInvitesService,
  IRecallAllUnusedInvitesMethods,
  RecallAllUnusedInvitesService,
  IAllDiscountListsMethods,
  ISingleRecallMethods,
  SingleRecallService,
  IDiscountRecallMethods,
  discountRecallService,
  SenddiscountInviteUserService,
  AllDiscountListsService,
  ISenddiscountInviteMethods
} from "./components";

export type UsersListPageAgent = IHeaderMethods &
  ISettingsMethods &
  IStaticPageContentMethods &
  IInviteUserMethods &
  IUserListsMethods &
  IPresentationListsMethods &
  ISendPurchaseInviteMethods &
  IUserDropDownListsMethods &
  ISearchEmailMethods &
  ICheckCountInviteMethods &
  IReInviteUserMethods &
  IUpdateMaxInvitesMethods &
  ICommitteListMethods &
  ISenddiscountInviteMethods &
  AllDiscountListsService &
  ISingleRecallMethods &
  IDiscountRecallMethods &
  IRecallAllUnusedInvitesMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new HeaderService(),
    new SettingsService(),
    new UserListsService(),
    new InviteUserService(),
    new PresentationListsService(),
    new SendPurchaseInviteUserService(),
    new SearchEmailService(),
    new UserDropDownListsService(),
    new ReInviteUserService(),
    new CheckCountInviteService(),
    new CommitteListService(),
    new SingleRecallService(),
    new discountRecallService(),
    new UpdateMaxInvitesService(),
    new SenddiscountInviteUserService(),
    new RecallAllUnusedInvitesService(),
    new AllDiscountListsService(),
  ];
};

export const getAgent = () => {
  return createAgent<UsersListPageAgent>({
    plugins: getPlugins(),
  });
};
